import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube } from "lucide-react";

export const Footer = () => (
  <footer className="bg-black text-white py-20 md:py-28 mt-0" data-testid="footer">
    <div className="max-w-[1400px] mx-auto px-5 md:px-8">
      <div className="grid md:grid-cols-4 gap-12 mb-16">
        <div className="md:col-span-2">
          <img src="/logo.png" alt="Unlimited Gear" className="h-28 md:h-36 w-auto" data-testid="footer-logo" />
          <p className="font-mono text-sm text-white/60 mt-5 max-w-xs">
            From punk to sports to fitness. Buy the tee or pick a print — we'll mail it to your door.
          </p>
        </div>
        <div>
          <h4 className="font-outfit font-bold uppercase text-sm tracking-widest mb-4 text-primary">Shop</h4>
          <ul className="space-y-2 font-mono text-sm text-white/70">
            <li><Link to="/shop?category=punk" className="hover:text-white">Punk</Link></li>
            <li><Link to="/shop?category=sports" className="hover:text-white">Sports</Link></li>
            <li><Link to="/shop?category=fitness" className="hover:text-white">Fitness</Link></li>
            <li><Link to="/shop?type=print" className="hover:text-white">Prints</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-outfit font-bold uppercase text-sm tracking-widest mb-4 text-primary">Account</h4>
          <ul className="space-y-2 font-mono text-sm text-white/70">
            <li><Link to="/account" className="hover:text-white">My Orders</Link></li>
            <li><Link to="/login" className="hover:text-white">Sign In</Link></li>
            <li><Link to="/cart" className="hover:text-white">Cart</Link></li>
          </ul>
          <div className="flex gap-4 mt-6">
            <Instagram size={20} className="hover:text-primary cursor-pointer" />
            <Twitter size={20} className="hover:text-primary cursor-pointer" />
            <Youtube size={20} className="hover:text-primary cursor-pointer" />
          </div>
        </div>
      </div>
      <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between gap-3 font-mono text-xs uppercase tracking-widest text-white/40">
        <span>© 2026 getunlimitedgear.com</span>
        <span>Built for the bold.</span>
      </div>
    </div>
  </footer>
);
